import { LOCATIONS, daysAgo } from './dataset';

// ReviewsInbox™ (/reviews) and the review endpoints other Reputation pages share.
const REVIEWERS = ['Jordan Ellis', 'Sam Okafor', 'Riley Chen', 'Morgan Price', 'Casey Lindqvist', 'Avery Brooks', 'Jamie Ortega', 'Taylor Nguyen'];

const review = (i, {
	source,
	rating,
	comment,
	replied
}) => {
	const loc = LOCATIONS[i % LOCATIONS.length];
	const r = {
		source,
		reviewDocId: `rv-${i}`,
		reviewId: `rv-${i}`,
		reviewToken: `rv-token-${i}`,
		locationId: loc.locationId,
		masterLocationId: loc.locationId,
		locationName: loc.locationName,
		friendlyName: loc.locationName,
		starRating: rating,
		comment,
		createTime: daysAgo(i + 1),
		updateTime: daysAgo(i + 1),
		readReview: i > 2,
		replyStatus: replied ? 'SENT' : '',
		replySentFromLC: !!replied,
		autoReplyFromLC: false,
		isAiResponse: false,
		reviewCategory: []
	}; // Reviewer name lives in a different field per source (see ReviewsPage/SourceConfig.js).

	if (source === 'google') r.reviewer = {
		displayName: REVIEWERS[i]
	};else r.name = REVIEWERS[i];
	return r;
};

export const REVIEWS = [review(0, {
	source: 'google',
	rating: 5,
	comment: 'Friendly baristas and my latte was ready in minutes. Our new favourite stop before work.'
}), review(1, {
	source: 'yelp',
	rating: 4,
	comment: 'Great cold brew and pastries. A short wait at the counter during the morning rush.'
}), review(2, {
	source: 'google',
	rating: 2,
	comment: 'Hard to find parking and the seating area was crowded on Saturday.'
}), review(3, {
	source: 'google',
	rating: 5,
	comment: 'Lovely seasonal menu and the team remembered my order.',
	replied: true
}), review(4, {
	source: 'yelp',
	rating: 3,
	comment: 'Coffee was fine, nothing that stood out compared to other cafes nearby.',
	replied: true
}), review(5, {
	source: 'google',
	rating: 4,
	comment: 'Clean store, fair prices and fast Wi-Fi for working.'
}), review(6, {
	source: 'google',
	rating: 1,
	comment: 'My mobile order was not ready at the pickup time shown in the app.'
}), review(7, {
	source: 'yelp',
	rating: 5,
	comment: 'Best oat milk flat white in town. Would recommend to friends.',
	replied: true
})];
const unanswered = REVIEWS.filter(r => !r.replySentFromLC);
export const BUBBLE_COUNT = {
	total: REVIEWS.length,
	awaitingResponse: unanswered.length,
	drafts: 0,
	outbox: 0,
	sent: REVIEWS.length - unanswered.length,
	approvalQueue: 0,
	closedReviews: 0,
	removedReviews: 0,
	userAssignedReviews: 0,
	teamReviews: 0,
	repliedCount: REVIEWS.length - unanswered.length,
	autoReply: 0,
	NEEDS_ASSISTANCE: 0,
	AWAITING_CUSTOMER: 0,
	AWAITING_FEEDBACK: 0,
	NEW_FEEDBACK: 0
};
export default {
	'/getReviews': () => ({
		hits: REVIEWS,
		total: REVIEWS.length
	}),
	'/getAwaitingResponseReviews': () => ({
		hits: unanswered,
		total: unanswered.length
	}),
	'/getReviewsTabBubbleCount': () => BUBBLE_COUNT,
	'/getAllReviewTags': () => ({
		status: 200,
		reviewTags: [{
			reviewTag: 'Friendly staff',
			key: 'friendly_staff'
		}, {
			reviewTag: 'Wait time',
			key: 'wait_time'
		}, {
			reviewTag: 'Espresso',
			key: 'espresso'
		}, {
			reviewTag: 'Pastries',
			key: 'pastries'
		}, {
			reviewTag: 'Cleanliness',
			key: 'cleanliness'
		}]
	}),
	'/getInboxReplies': () => ({
		hits: [],
		total: 0
	})
};